import { Link } from 'react-router-dom';

import { Container, Section } from '@/components/common';
import { routes } from '@/config/routes';
import { useDocumentMetadata } from '@/hooks/useDocumentMetadata';

export function UnauthorizedPage() {
  useDocumentMetadata('Access Denied');
  return (
    <Section spacing="large">
      <Container size="narrow">
        <div className="state-card">
          <i className="pi pi-lock" aria-hidden="true" />
          <h1>That area is not available to this account</h1>
          <p>
            You are signed in, but this account does not have permission to open the requested area.
          </p>
          <div className="button-row">
            <Link className="button-link button-link--primary" to={routes.dashboard}>
              Go to dashboard
            </Link>
            <Link className="button-link button-link--secondary" to={routes.home}>
              Visit storefront
            </Link>
          </div>
        </div>
      </Container>
    </Section>
  );
}
